import { vueForAudiCode, vueForPRString, vueForRawData, vueRangeForCarline } from "@oneaudi/vue-formatter";
const VueFormatterServiceCreatorV1 = (options) => {
    return {
        create: (consumerId, env) => {
            return {
                featureService: new VueFormatterServiceV1(consumerId, options, env),
            };
        },
    };
};
class VueFormatterServiceV1 {
    constructor(consumerId, options, env) {
        this.i18nMessages = undefined;
        this.serviceConfig = {};
        this.serviceConfig = this.mapServiceConfig(options);
        this.consumerId = consumerId;
        this.i18nService = env["featureServices"]["dbad:audi-i18n-service"];
        this.i18nService.setScopes(["vue"]);
        this.localeService = env["featureServices"]["locale-service"];
    }
    mapServiceConfig(options) {
        const config = {};
        if (options.VUE_AGW_ENDPOINT) {
            config["VUE_AGW_ENDPOINT"] = options.VUE_AGW_ENDPOINT;
        }
        return config;
    }
    async getMessages() {
        if (this.i18nMessages == undefined) {
            await this.i18nService.setLocale();
            this.i18nMessages = this.i18nService.getMessages();
        }
        return this.i18nMessages[this.localeService.language];
    }
    async vueForAudiCode(country, language, audiCode) {
        const resources = await this.getMessages();
        const vue = await vueForAudiCode(country, language, audiCode, resources, this.serviceConfig);
        return vue;
    }
    async vueForPRString(country, language, prString) {
        const resources = await this.getMessages();
        const vue = await vueForPRString(country, language, prString, resources, this.serviceConfig);
        return vue;
    }
    async vueForRawData(country, language, rawData) {
        const resources = await this.getMessages();
        const vue = vueForRawData(country, language, rawData, resources);
        return vue;
    }
    async vueRangeForCarline(country, language, carlineId) {
        const resources = await this.getMessages();
        const vue = await vueRangeForCarline(country, language, carlineId, resources, this.serviceConfig);
        return vue;
    }
}
export { VueFormatterServiceCreatorV1, };
//# sourceMappingURL=vue-formatter-feature-service.js.map